import { FluidOutputTemplate } from "../../../features/reporting/templates/FluidOutputTemplate";

export function FluidOutputReportScreen() {
  return <FluidOutputTemplate />;
}
